import { faStop } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../../Components/Form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import {
    ListarMotivoParalisarController,
    ParalisarAtendimentoController,
} from "../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { IParalisarManutencao } from "../../../../../Interfaces/AssistenciaTecnica/Atendimento/ParalisarManutencao/ParalisarManutencaoInterfaces";
import { IAtendimentoExtraDetalhado } from "../../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";

interface IParalisarManutencaoProps {
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function ParalisarManutencao(props: IParalisarManutencaoProps) {
    const { updateAtendimento, ID_CASO, Atendimento } = useAtendimentoPage();

    const AtendimentoDetalhado = Atendimento as IAtendimentoExtraDetalhado;

    const { execute: executarParalisarManutencao, loading } = useAsyncCallback(
        ParalisarAtendimentoController
    );

    const handleParalisarManuntecaoFormSubmit = (
        formData: IParalisarManutencao
    ) => {
        executarParalisarManutencao({ ...formData, ID_CASO }).then(() => {
            updateAtendimento();
            props.setShow(false);
        });
    };

    return (
        <UnForm handleSubmit={handleParalisarManuntecaoFormSubmit}>
            <div className="mb-8">
                <div className="row m-0 ">
                    <UnForm.LazySelect
                        controller={ListarMotivoParalisarController}
                        label="Motivo de Paralisação"
                        name="ID_MOTIVO_PARALIZACAO_SLA"
                        className={`form-control placeholder-dark-50`}
                        wrapperClassName="col-12 col-md-12 m-0"
                        getDS={(p) => p.DS_MOTIVO_PARALIZACAO_SLA}
                        getKeyValue={(p) => p.ID_MOTIVO_PARALIZACAO_SLA}
                    >
                        <option></option>
                    </UnForm.LazySelect>
                </div>
            </div>

            <UnForm.SubmitButton
                color="success"
                wrapperClassName="w-100 mt-8 col-12 col-md-12"
                className="w-100"
                icon={faStop}
                loading={loading}
                disabled={
                    loading || AtendimentoDetalhado.FL_SINCRONIZADO === false
                }
                loadingSize={"sm"}
            >
                Paralisar Reparo
            </UnForm.SubmitButton>
        </UnForm>
    );
}
